import React from 'react'
import Layout from '../components/layout'
import { courseKeys, courseModulesV2 } from '../courses/coursesDataList'
import { ICourse2, IProject } from '@et/types/Courses'
import ColoredBar from '@components/dividers/coloredBar'
import Section3 from '@components/sections/section3'
import { DarkTheme } from '@styles/themes/darkTheme'
import Curriculum from '@components/sections/curriculum'
import Faq from '@components/sections/faqs/faq'
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyPageProps } from '@et/types/Gatsby'

import SectionA from '@components/sections/sectionA'
import CourseCardLayoutA from '@components/sections/courseCard/courseCardLayoutA'
import PayWhatYouWant from '@components/sections/payWhatYouWant/payWhatYouWant'
import StandardHeroImgV3 from '@components/imageModules/v3/heroImg_v3'
import IPadImgV3 from '@components/imageModules/v3/iPadImgv3'
import InstructorLayoutBV3 from '@components/sections/intructorLayoutB_v3'
import GatsbySEO from '@components/sections/seo/seo_v3'

import StandardHeroImgV4 from '@components/imageModules/v4/heroImg_v4'
import IPadImgV4 from '@components/imageModules/v4/iPadImgV4'
import ProjectModuleOneV4 from '@components/projects/projectModuleOne_v4'
import InstructorLayoutBV4 from '@components/sections/instructor/intstructorLayoutB_v4'
import BonusLayoutAv4 from '@components/sections/bonusesLayout/bonusLayoutA_v4'
import CourseCardLayoutV4 from '@components/sections/courseCard/courseCardLayout_v4'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import CtaButton from '@components/buttons/ctaButton'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { JsonLdFaqString } from '@utils/jsonLdUtils'

const course: ICourse2 = courseModulesV2[courseKeys.Procreate101]

const ProcreateForBeginnersPage = (props: IGatsbyPageProps) => {
  const { heroImg, dividerImg1, dividerImg2, dividerImg5, introImg, ipadFlatDrk, ipadSmall, section3Img, projectImg_1_full, projectImg_2_full, projectImg_3_full, projectImg_4_full, profileImg, dividerImg3, dividerImg4, bonusImg1, bonusTitle, bonusImg2, bonusImg3, bonusImg4, courseCardBg, courseCardTitle, letsDoThis, SellCardImg, projectImg_4_video, profileBorder } = useStaticQuery(
    graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    author
                    siteUrl
                }
            }
            heroImg: imgixImage(url: "procreate101/procreate-for-beginners.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000,
                    auto: "compress"
                })
            }
            dividerImg1: imgixImage(url: "procreate101/env-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            dividerImg2: imgixImage(url: "procreate101/env-5.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            dividerImg3: imgixImage(url: "procreate101/env-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            dividerImg4: imgixImage(url: "procreate101/env-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            dividerImg5: imgixImage(url: "procreate101/env-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            introImg: imgixImage(url: "procreate101/tablet-side-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 600
                })
            }
            ipadFlatDrk:  imgixImage(url: "ipad-device-1.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            ipadSmall: imgixImage(url: "ipad-device-small.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            section3Img: imgixImage(url: "procreate101/class-projects.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            projectImg_1_full: imgixImage(url: "procreate101/project-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    auto: "compress",
                    w: 1700
                })
            }
            projectImg_2_full: imgixImage(url: "procreate101/project-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    auto: "compress",
                    w: 1700
                })
            }
            projectImg_3_full: imgixImage(url: "procreate101/project-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    auto: "compress",
                    w: 1700
                })
            }
            projectImg_4_full: imgixImage(url: "procreate101/project-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    auto: "compress",
                    w: 1700
                })
            }
            projectImg_4_video: file(relativePath: { eq: "procreate101/project4.mp4"}) {
                publicURL
            }
            profileImg: imgixImage(url: "teela-profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            profileBorder: imgixImage(url: "procreate101/profile-border-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            bonusTitle: imgixImage(url: "procreate101/bonuses-title-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            bonusImg1: imgixImage(url: "procreate101/bonuses-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            bonusImg2: imgixImage(url: "procreate101/bonuses-6.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            bonusImg3: imgixImage(url: "procreate101/bonuses-5.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            bonusImg4: imgixImage(url: "procreate101/bonuses-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            courseCardBg: imgixImage(url: "procreate201/sell-card-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            courseCardTitle: imgixImage(url: "procreate101/course-card-title-min.png"){
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            }
            letsDoThis: imgixImage(url: "procreate101/lets-do-this-min.png"){
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            SellCardImg: imgixImage(url: "procreate101/sell-card.jpg"){
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
        }
    `,
  )
  const project1Images = [
    { ...projectImg_1_full },
    { ...projectImg_2_full },
    { ...projectImg_3_full },
    {
      ...projectImg_4_video,
      ...projectImg_4_full,
    },
  ]
  const bonusImages = [
    {
      gatsbySource: { ...bonusImg1 },
      alt: course.bonuses.items[0].imgAlt,
    },
    {
      gatsbySource: { ...bonusImg2 },
      alt: course.bonuses.items[1].imgAlt,
    },
    {
      gatsbySource: { ...bonusImg3 },
      alt: course.bonuses.items[2].imgAlt,
    },
    {
      gatsbySource: { ...bonusImg4 },
      alt: course.bonuses.items[3].imgAlt,
    },
  ]

  return (
    <Layout theme={DarkTheme} path={props.location.pathname}>
      <GatsbySEO
        course={course}
        classCard={'https://et-teachable.imgix.net/procreate101/procreate-for-beginners.jpg?w=1024'}>
        <link rel='preconnect' href='https://fonts.gstatic.com' />
        <link
          href='https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500&display=swap'
          rel='stylesheet' />
        <script type="application/ld+json">{JsonLdFaqString(course.faqs)}</script>
      </GatsbySEO>
      <h1 style={{ opacity: 0, height: 0, margin: 0 }}>Intro to Procreate</h1>

      {/* <!-- hero img --> */}
      <StandardHeroImgV4
        img={heroImg}
        classes={'mb-10'}
        alt={`Intro to procreate for beginners`} />

      {/*<!-- intro desc -->*/}
      {/*<ColoredBar text={course.tagline} color={`#d99e36`}/>*/}

      {/*<!-- feature bg image -->*/}
      <BackgroundImageV5
        containerStyles={{
          backgroundColor: DarkTheme.backgroundPrimary,
        }}
        gatsbyDataImg={dividerImg1}>
        <CourseTagline>
          <div className={'content'}>
            {course.tagline}
          </div>
        </CourseTagline>
      </BackgroundImageV5>

      {/*<!-- intro class description -->*/}
      <SectionA
        {...course}
        gatsbyImg={introImg}
        ctaButton={<CtaButton id={'mini-card'} text={'Enroll for Free!'} />}
      />

      {/*<!-- feature bg image -->*/}
      <BackgroundImageV5
        containerStyles={{
          backgroundColor: DarkTheme.backgroundPrimary,
        }}
        gatsbyDataImg={dividerImg2} />

      {/*<!-- Projects Intro: Beginner -->*/}
      <Section3
        headline={modules.projectIntroBeg.headline}
        description={modules.projectIntroBeg.description}
        backgroundColor={DarkTheme.backgroundPrimary}
        textColor={DarkTheme.headlineColor}
        ImageComponent={<IPadImgV4 alt={`Intro to procreate for beginners`}
          img={section3Img}
          iPadImg={ipadFlatDrk} />}
      />

      {/*<!-- Beginner Projects -->*/}
      {course.projects &&
        course.projects.beginner.map((project: IProject, index: number) => {
          const projectImage = project1Images[index]
          return (
            <ProjectModuleOneV4
              video={project.video}
              videoSrc={project.video ? projectImage.publicURL : null}
              key={project.title}
              reverse={index % 2 !== 0}
              gatsbyImage={projectImage}
              {...project}
            />
          )
        })}

      <InstructorLayoutBV4 profileImg={profileImg} streakImg={profileBorder} />

      <BackgroundImageV5 gatsbyDataImg={dividerImg3}
        containerStyles={{
          backgroundColor: DarkTheme.backgroundPrimary,
        }} />

      <Curriculum {...course} showEnrollBtn={true} />

      <BackgroundImageV5 gatsbyDataImg={dividerImg4}
        containerStyles={{
          backgroundColor: DarkTheme.backgroundPrimary,
        }} />

      <BonusLayoutAv4
        bonusSection={course.bonuses}
        headerImg={{ gatsbySource: bonusTitle, alt: 'Procreate for beginners Bonuses!' }}
        iPadSmall={ipadSmall}
        bonusImages={bonusImages}
      />

      {/*<!-- Course Sell Card -->*/}
      <CourseCardLayoutV4 backgroundGatsbyImg={courseCardBg} titleImg={courseCardTitle} course={course} />

      <Faq faqs={course.faqs} textActivatedColor={'#fff'} activeBgColor={`#3d3d3d`} />

      <BackgroundImageV5 gatsbyDataImg={dividerImg5}
        containerStyles={{
          backgroundColor: DarkTheme.backgroundPrimary,
        }} />

      <PayWhatYouWant
        {...course}
        procreateLogo={letsDoThis}
        shadows={DarkTheme.shadows.i800}
        iconColor={`#ffad29`}
        cardImage={SellCardImg} />

    </Layout>
  )
}
const modules = {
  flexibleMethods: {
    headline: 'Flexible 3D Methods',
    description:
      'Whether you wish to add subtle shadow and highlight details to your lettering or bring in extra tricks to enhance your Instagram feed, you’re covered. We start with 3D basics, so you can take your 3D experiments as far as you’d like to go. Throughout the more advanced projects, you’ll learn exactly how to implement believable shading and highlights in an editable file you can flexibly adjust however you’d like in the future.',
  },
  projectIntroBeg: {
    headline: 'Made for Beginners',
    description:
      'The entire course was made with beginners in mind. We take a slower pace and go through everything in detail. After lessons describing tools or methods, we follow them right afterwards with a project to hit everything home. Understanding how tools work is one thing; using them to create something you’re proud of is another very important one.',
  },
}

export default ProcreateForBeginnersPage

const CourseTagline = styled.div`
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  z-index: 2;
  position: relative;

  .content {
    color: #fff;
    background: rgba(63, 40, 8, 0.55);
    padding: 1rem 2rem;
    font-size: 1.5rem;
    text-align: center;

    @media ${device.tablet}{
      font-size: 2rem;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  @media ${device.tablet}{
    min-height: 500px;
  }

  @media ${device.laptop}{
    min-height: 700px;
  }
`
